import Service from '@ember/service';
import { getOwner } from '@ember/application';
import { inject as service } from '@ember/service';
import { all, hash, resolve } from 'rsvp';
import EmberObject from '@ember/object';
import { filterBy } from '@ember/object/computed';
import { camelize } from '@ember/string';

export default class CurrentEmpresaService extends Service {
  @service store;

  @service session;

  // @service toast;

  empresa = null;

  modulos = null;

  parameters = null;

  empParameters = null;

  karParameters = null;

  @filterBy('modulos', 'directorio', 'KARDEX') kardexModule;

  load() {
    let token = this.session.data.authenticated.token;

    if (!token) {
      throw Error('User not authenticated.');
    }

    let authenticator = getOwner(this).lookup('authenticator:jwt');
    let userData = authenticator.getTokenData(token).username.split('@', 2);

    if (!userData || userData.length < 2) {
      throw Error('Empresa code not found from session data.');
    }

    let codempresa = userData[1];

    // this.loader.setLoading(true);

    return this.store
      .query('empresa', {
        filter: {
          codempresa: {
            exact: codempresa,
          },
        },
        include: 'pais',
      })
      .then((result) => {
        if (0 === result.length) {
          throw Error(`Got no record for empresa '${codempresa}'.`);
        }

        if (1 !== result.length) {
          throw Error(`Got more than one record for empresa '${codempresa}'.`);
        }

        this.set('empresa', result[0]);
      })
      .then(() =>
        all([
          this.loadModulos(),
          this.loadParameters(),
          this.loadEmpParameters(),
        ]),
      )
      .then(() => this.loadKarParameters())
      .then(() => this.empresa)
      .catch((error) => {
        // this.toast.error('No es posible acceder en este momento.');

        throw error;
      });
    // .finally(() => this.loader.setLoading(false));
  }

  loadModulos() {
    return this.store.query('modulo', {}).then((modulos) => {
      this.set('modulos', modulos);
    });
  }

  loadParameters() {
    return hash({
      empParameters: this.store.query('parametro', {
        filter: {
          empresa: this.empresa.id,
        },
      }),
      globalParameters: this.store.query('parametro', {
        filter: {
          empresa: {
            exists: false,
          },
        },
      }),
    }).then(({ empParameters, globalParameters }) => {
      let parameters = [...empParameters, ...globalParameters].reduce(
        (parametersObj, parameterObj) => {
          let parameter = camelize(parameterObj.get('parametro').trim());
          let valor = parameterObj.get('valor').trim();

          if (!isNaN(parseFloat(valor))) {
            parametersObj.set(parameter, parseFloat(valor));
          } else if (['true', 'yes', '1'].includes(valor)) {
            parametersObj.set(parameter, true);
          } else if (['false', 'no', '0'].includes(valor)) {
            parametersObj.set(parameter, false);
          } else {
            parametersObj.set(parameter, valor);
          }

          return parametersObj;
        },
        new EmberObject(),
      );

      this.set('parameters', parameters);
    });
  }

  loadEmpParameters() {
    if (!this.empresa) {
      return resolve(true);
    }

    return this.store
      .query('emp-parametros-generales', {
        filter: {
          empresa: this.empresa.id,
        },
      })
      .then((empParameters) => {
        this.set(
          'empParameters',
          empParameters.length ? empParameters[0] : null,
        );
      });
  }

  loadKarParameters() {
    if (!this.empresa || !this.kardexModule.length) {
      return resolve(true);
    }

    return this.store
      .query('kar-parametro', {
        filter: {
          empresa: this.empresa.id,
        },
      })
      .then((karParameters) => {
        this.set(
          'karParameters',
          karParameters.length ? karParameters[0] : null,
        );
      });
  }
}
